import Vue from "vue";
import App from "./App.vue";
import "./assets/flex-grid-lite/_flex-grid-lite.scss";
import "./assets/styles.scss";

// To temporary show mockup design
import "./assets/temporary-mockup-scss/placeholder-loading.scss";

import router from "./router";

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
